module.exports = __webpack_public_path__ + "multifamily-bridge.06ee2e0.jpg";